import axios from 'axios'
import store from '../../src/store'
import MySession from './mySession'
import MyCrypt from './myCrypt'

export default {
  $post (op) {
    let _url = process.env.API_ROOT;

    let token = null;
    _url += op.url;
    let headers = { platform: 'web' };
    if (op.url !== '/sop/login') {
      token = store.state.user.token
    }
    if(op.url=='/sop/search/file/upload'){
      headers={'Content-Type':'multipart/form-data', platform: 'web'}
    }
    if (token) headers.token = token;
    return axios({ withCredentials: false, headers, url: _url, timeout: 120000, method: 'post', data: op.reqdata ? op.reqdata : {} })

  },
  $get (op) {
    let _url = process.env.API_ROOT;
    if (op.url) {
      _url += op.url;
    } else {
      if (op.data.type) {
        _url += '/api/request/' + op.data.type;
      } else {
        _url += '/api/request';
      }
    }
    return axios({ withCredentials: true, url: _url, timeout: 60000, method: 'get' })
  },
  $syncPost (op) {
    return new Promise((rs) => {
      this.$post(op).then(res => {
        rs([null, res.data]);
      }).catch(err => {
        rs(['网络异常，请稍后再试！', null]);
      })
    });
  },
  $syncGet (op) {
    this.$get(op).then(res => {
      rs([null, res.data]);
    }).catch(err => {
      rs(['网络异常，请稍后再试！', null]);
    })
  }
}



// WEBPACK FOOTER //
// ./src/config/myHttp.js